import { MANAGED_STRUCTURE_TYPE_ID, NOT_ACTIVE_ONLINE } from "theme/config/constants";
import getProductStockStatus, { getPackageStockStatus } from "core-web/utils/getProductStockStatus";

import { getFlag } from "core-web/utils/getFlag";
import { isEmpty } from "core-web/utils/object";

export default (product) => {
    if (!product || isEmpty(product)) {
        return {};
    }

    const productClone = JSON.parse(JSON.stringify(product));
    const {
        name,
        variant_name: variantName,
        price: priceExVat,
        price_standard: standardPriceExVat,
        price_list_id: priceListId,
        price_list_code: priceListCode,
        vat_rate: vatRate,
        id: productId,
        ean_code: eanCode,
        categoryPrimary,
        format: { flags, image },
        manufacturer,
        url,
        part_no: partNo,
        on_hand: onHand,
        on_hand_store: onHandStore,
        type,
        variants,
        parametrics,
        variant_parametrics: variantParametrics,
        included_products: includedProducts,
    } = productClone;

    const filteredVariants = (variants || []).filter((variant) => !getFlag(NOT_ACTIVE_ONLINE, variant?.format?.flags));
    const isVariant = filteredVariants.length > 1;

    const isPackage = type === MANAGED_STRUCTURE_TYPE_ID;
    let stockStatus, stockStatusStore;
    if (isPackage) {
        [stockStatus, stockStatusStore] = getPackageStockStatus(includedProducts);
    } else {
        stockStatus = getProductStockStatus(onHand);
        stockStatusStore = getProductStockStatus(onHandStore);
    }
    const inStock = !!stockStatus.stock;

    const manufacturerName = manufacturer?.name;

    return {
        // categories,
        partNo,
        eanCode,
        name: variantName || name,
        priceExVat,
        standardPriceExVat,
        vatRate,
        categoryPrimary,
        flags,
        manufacturerName,
        url,
        parametrics,
        variantParametrics,
        variants: filteredVariants,
        image,
        isVariant,
        productId,
        stockStatus,
        stockStatusStore,
        inStock,
        isPackage,
        priceListId,
        priceListCode,
        includedProducts,
    };
};
